import { render, staticRenderFns } from "./fieldTableDataView.vue?vue&type=template&id=e77e7fc2&scoped=true"
import script from "./fieldTableDataView.vue?vue&type=script&lang=js"
export * from "./fieldTableDataView.vue?vue&type=script&lang=js"
import style0 from "./fieldTableDataView.vue?vue&type=style&index=0&id=e77e7fc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e77e7fc2",
  null
  
)

export default component.exports